import { useEffect, useState } from "react";
import api from "../lib/api";
import { Check, Sparkles, ArrowRight } from "lucide-react";
import { toast } from "sonner";

// Hostro Pricing / Subscription page — Free / Growth / Pro / Visitor-Only.
// Uses /api/pms/plans; CTA links to owner onboarding.
export default function Pricing() {
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/pms/plans").then(r => setPlans(r.data)).catch(()=>{}); }, []);

  return (
    <div className="min-h-screen py-16 px-4" style={{background:"radial-gradient(1200px 700px at 15% -10%, rgba(52,201,123,0.12), transparent 60%), #0D1B2A", fontFamily:"Inter, ui-sans-serif, system-ui"}} data-testid="pricing-page">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest bg-[#34C97B]/15 text-[#34C97B] border border-[#34C97B]/30">
            <Sparkles size={12}/> Hostro PMS Plans
          </div>
          <h1 className="mt-4 text-4xl md:text-6xl font-black text-white" style={{letterSpacing:"-0.02em"}}>Priced by bed. <span className="text-[#34C97B]">Not by pain.</span></h1>
          <p className="mt-4 text-white/60 max-w-2xl mx-auto">Simple usage-based pricing. Every plan gets invoicing, payments, and reminders. Upgrade only when you grow.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {plans.map(p => (
            <div key={p.id} className={`rounded-2xl p-6 relative ${p.recommended?"border-2 border-[#34C97B]":"border border-white/10"}`} style={{background:p.recommended?"rgba(52,201,123,0.08)":"rgba(255,255,255,0.04)", backdropFilter:"blur(14px)"}} data-testid={`plan-${p.id}`}>
              {p.recommended && (
                <span className="absolute -top-3 left-6 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest bg-[#34C97B] text-white">Recommended</span>
              )}
              <div className="text-xs uppercase tracking-widest text-white/50">{p.name}</div>
              <div className="mt-3 text-white">
                <span className="text-4xl font-black">₹{p.price}</span>
                {p.unit && <span className="text-sm text-white/60 ml-1">{p.unit}</span>}
              </div>
              {p.min && <div className="text-xs text-white/50 mt-1">min ₹{p.min}/mo</div>}
              {p.bed_limit && <div className="text-xs text-white/60 mt-2">Up to {p.bed_limit} beds</div>}

              <ul className="mt-5 space-y-2">
                {p.features.map(f => (
                  <li key={f} className="text-sm text-white/80 flex items-start gap-2">
                    <Check size={14} className="text-[#34C97B] mt-0.5 shrink-0"/><span>{f}</span>
                  </li>
                ))}
              </ul>
              <button onClick={()=>toast(p.id==="free"?"Register as owner to start free":"Contact sales — sales@hostro.in")} className={`mt-6 w-full py-3 rounded-xl font-bold inline-flex items-center justify-center gap-1.5 transition ${p.recommended?"bg-[#34C97B] hover:bg-[#22B36A] text-white":"bg-white/5 hover:bg-white/10 border border-white/15 text-white"}`} data-testid={`cta-${p.id}`}>
                {p.cta} <ArrowRight size={14}/>
              </button>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center text-xs text-white/40">
          Powered by Razorpay Subscriptions · Cancel anytime · GST invoices provided.
        </div>
      </div>
    </div>
  );
}
